<template>
  <div id="app">

    <Header routeValue="3"></Header>
    <content class="content_details">
      <div class="ad_banner">
        <img style="width: 100%;height: 100%" :src="adBanner">
      </div>
      <div class="content_info">
        <div class="label">
          <div v-for="(item, index) in selectNames" :key="index">
            <a @click="toProducts(item.id)">{{ item.name }}</a>
            <span v-if="index !== selectNames.length - 1" style="margin: 0 5px">/</span>
          </div>
        </div>
        <div class="banner_box">
          <div class="swiper_box">
            <div class="dots_prev_button" @click="goToSlidePrev()"
                 v-if="skuDesInfo.atlas&&skuDesInfo.atlas.length>7&&scrollPosition<0">
              <a-icon type="up" style="font-size: 16px;color: #FFFFFF"/>
            </div>
            <div class="dots_next_button" @click="goToSlideNext()"
                 v-if="skuDesInfo.atlas&&skuDesInfo.atlas.length>7&&scrollPosition>-246">
              <a-icon type="down" style="font-size: 16px;color: #FFFFFF"/>
            </div>
            <!-- swiper Thumbs -->
            <a-carousel arrows dots-class="slick-dots slick-thumb"  ref="carousel" effect="fade">
              <a slot="customPaging" style="transition: transform 0.3s ease;overflow: auto" slot-scope="props"
                 :style="{transform: `translate3d(0px, ${scrollPosition}px, 0px)`}">
                <img :src="skuDesInfo.atlas[props.i].img | imgFilter(76)"/>
              </a>
              <div slot="prevArrow" id="prevArrow" slot-scope="props" class="slick_arrow" style="left: 8px"
                   @mouseover="hideArrows">
                <img src="../assets/icon_left.png"/>
              </div>
              <div slot="nextArrow" id="nextArrow" slot-scope="props" class="slick_arrow" style="right: 50px"
                   @mouseover="hideArrows">
                <img src="../assets/icon_right.png"/>
              </div>
              <div v-for="item in skuDesInfo.atlas">
                <div class="img_box" @mouseover="hideArrows" @mouseleave="showArrows">
                  <img :src="item.img | imgFilter(580)" alt="image"/>
                </div>
              </div>
            </a-carousel>
          </div>
          <div class="banner_info">
            <span class="title" v-wechat-title="getWechatTitle()"
                  :title="skuDesInfo.productNameEn || 'N/A' ">{{ skuDesInfo.productNameEn || 'N/A' }}</span>
            <div class="price_view">
              <span class="price">Price：</span>
              <div class="price_box">
                <div class="item" v-for="item in matchObj.vipPrice" v-if="Object.keys(item).length !== 0">
                <span class="item_price">
                  ${{ item.price }}
                </span>
                  <span class="item_rank">
                  <img src="../assets/titanium.png" style="margin-top: -2px" v-if="item.level===0"/>
                  <img src="../assets/platinum.png" style="margin-top: -2px" v-else-if="item.level===1"/>
                  <img src="../assets/diamond.png" style="margin-top: -2px" v-else/>
                  {{ item.level === 0 ? 'Titanium' : item.level === 1 ? 'Platinum' : 'Diamond' }}
                </span>
                </div>
              </div>
            </div>
            <div class="price_box" style="margin-top: 30px">
              <div class="item">
                <span class="item_time">
                  Production time
                </span>
                <span class="item_day">
                  {{ skuDesInfo.performanceTime || 0 }}-{{ skuDesInfo.performanceTimeEnd || 0 }}<span
                  style="font-size: 18px;color: #555555">days</span>
                </span>
              </div>
              <div class="item" style="width: auto;">
               <span class="item_time">
                  SPU
                </span>
                <span class="item_day">
                 {{ skuDesInfo.productCode }}
                </span>
              </div>
            </div>
            <div class="spec_box" ref="designsBox">
              <div>
                <div v-for="(productItem, productIndex) in specifications">
                  <div class="subhead">{{ productItem.name }}</div>
                  <div class="spec_list">
                    <div v-for="(oItem, oIndex) in productItem.item" :key="oItem.name">
                      <div :class="{ noneActive1: !oItem.checked, active1: subIndex[productIndex] === oIndex }"
                           @click="selectArrayBtn(oItem, productIndex, oIndex)" class="spec_item1"
                           v-if="oItem.colorValue">
                        <div
                          :style="{background:oItem.colorValue,width:'30px',height: '30px',borderRadius: '50%'}"></div>
                      </div>
                      <div :class="{ noneActive: !oItem.checked, active: subIndex[productIndex] === oIndex }"
                           @click="selectArrayBtn(oItem, productIndex, oIndex)" class="spec_item" v-else>
                        {{ oItem.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn_box">
              <div class="btn" @click="toNewOrder">Start new order</div>
              <a-tooltip placement="topLeft" :overlayStyle="{'color': 'rgba(0, 0, 0, 1)','max-width':'1500px'}"
                         v-if="!skuDesInfo.hasDesignTemplate">
                <template slot="title">
                  <div
                    style="font-family: Roboto;font-weight: 400;font-size: 14px;color: #FFFFFF;line-height: 18px;margin:1px 2px;">
                    The mockup isn't ready yet.
                    <br>
                    Contact support if you need to use it urgently.
                  </div>
                </template>
                <div :class="'btn1 ' + (skuDesInfo.hasDesignTemplate ? '' : 'disabled')" @click="toCreateTemplate">
                  Create Product Template
                </div>
              </a-tooltip>
              <div v-if="skuDesInfo.hasDesignTemplate"
                   :class="'btn1 ' + (skuDesInfo.hasDesignTemplate ? '' : 'disabled')" @click="toCreateTemplate">Create
                Product Template
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="tabs_box">
        <a-tabs default-active-key="Description" @change="callback" :animated="false">
          <a-tab-pane key="Description" tab="Description">
            <div>
              <iframe
                ref="myIframe"
                :srcdoc="skuDesInfo.desc"
                @load="adjustIframeSize"
                style="border: none; width: 100%">
              </iframe>
            </div>
          </a-tab-pane>
          <a-tab-pane key="Pricing" tab="Pricing">
            <div class="spec_des_box">
              <table style="width: 100%">
                <thead class="ant-table-thead">
                <tr>
                  <th v-for="(spec,i) in skuDesInfo.skuVOList[0].specOptionVOS">
                    {{ spec.specsName }}
                  </th>
                  <th>Product code</th>
                  <th class="th_price">
                    <img src="../assets/titanium.png" v-if="vipLevel === 0"/>
                    <img src="../assets/platinum.png" v-else-if="vipLevel === 1"/>
                    <img src="../assets/diamond.png" v-else/>
                    {{ vipLevel === 0 ? ' Titanium' : vipLevel === 1 ? ' Platinum' : ' Diamond' }}
                  </th>
                  <th v-if="!token"></th>
                  <th class="th_price1" v-if="!token"><img src="../assets/platinum.png"/> Platinum</th>
                  <th v-if="!token"></th>
                  <th class="th_price2" v-if="!token"><img src="../assets/diamond.png"/> Diamond</th>
                </tr>
                </thead>
                <tbody class="ant-table-tbody">
                <tr v-for="(item,i) in skuDesInfo.skuVOList" :key="i" class="ant-table-row">
                  <td v-for="(spec,i) in item.specOptionVOS">
                    {{ spec.optionName }}
                  </td>
                  <td>
                    {{ item.sn }}
                  </td>
                  <td v-for="(vip, index) in item.vipPrice"
                      :key="index"
                      :style="getBorderStyle(vip.level, i,skuDesInfo.skuVOList)"
                      :class="[{'td_price': vip.level === 0,'td_price1': vip.level === 1, 'td_price2': vip.level === 2}]">
                    {{ Object.keys(vip).length !== 0 ? ' $' + vip.price : '' }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="Shipping" tab="Shipping">
            <div class="logistics_box">
              <div class="table_box">
                <div class="item" v-for="item in logisticsList" :class="{ active: item.checked}"
                     @click="tableChange(item)">
                  <div class="shipping">
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <a-table
                rowKey="key"
                :locale="tableLocale"
                :columns="columns"
                :data-source="stateList"
                :pagination="false">
                <span slot="price" slot-scope="text, record">
                    {{ record.price !== null ? '$' + record.price : record.price }}
                </span>
                <span slot="extraPrice" slot-scope="text, record">
                    {{ record.extraPrice !== null ? '$' + record.extraPrice : record.extraPrice }}
                </span>
              </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="Guidelines" tab="File Guidelines">
            <div style="margin-bottom: 8px;font-family: Roboto">
              <a style="font-size: 17px" :href="skuDesInfo.artTemplateUrl" target="_blank">
                Download templates and mockups here
              </a>
              <div style="font-size: 17px;color: #333333;margin-bottom: 25px;font-weight: bold;line-height: 2;">Print
                Guidelines
              </div>
            </div>
            <div>
              <iframe
                ref="myIframe"
                :srcdoc="designSpecContent"
                @load="adjustIframeSize"
                style="border: none; width: 100%">
              </iframe>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="item_divider"></div>
      <div class="like_box">
        <div class="title">You may also like</div>
        <a-carousel arrows :dots="false" autoplay :autoplay-speed="8000" style="cursor: pointer;">
          <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px;z-index: 1">
            <img src="../assets/prev.png"/>
          </div>
          <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: -10px;z-index: 1">
            <img src="../assets/next.png"/>
          </div>
          <div v-for="(obj,key) in recommendList" :key="key">
            <div v-for="(obj2,key) in obj.imgs" :key="key" class="hotBox" @click="handleSelectRecommend(obj2)">
              <div class="slide_box">
                <div class="img_box">
                  <img
                    class="img1" :src="obj2.productImg|imgFilter(318)">
                  <img
                    class="img2" :src="obj2.productTemplateImg|imgFilter(318)">
                </div>
                <span class="name">{{ obj2.productNameEn }}</span>
                <span class="price">From $ {{ obj2.minPrice }}</span>
                <span class="size">{{ obj2.spec }}</span>
                <div class="tag_box" v-if="false">
                  <img src="../assets/best@2x.png" v-if="isShowTag(obj2,'Bestsellers')"
                       style="width: 74px;margin-right: 3px">
                  <img src="../assets/new@2x.png" v-if="isShowTag(obj2,'New')" style="width: 40px;margin-right: 3px">
                  <img src="../assets/trd@2x.png" v-if="isShowTag(obj2,'Trending')" style="width: 67px">
                </div>
                <div class="tag_box">
                  <span class="new" v-if="isShowTag(obj2,'New')">New</span>
                  <span class="best" v-if="isShowTag(obj2,'Bestsellers')">Bestseller</span>
                  <span class="trd" v-if="isShowTag(obj2,'Trending')">Trending</span>
                </div>
              </div>

            </div>
          </div>
        </a-carousel>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import {get} from '@/api'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import {getCartesianProduct, getSeoLinkName, isIdEmpty, setDataToSpecs, setDifferenceArray, uuid} from '@/utils/utils'

export default {
  name: 'Details',
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide
  },
  data () {
    let that = this
    return {
      editorOption: {
        // 这里可以放置quill编辑器的配置
        readOnly: true // 设置为只读，仅展示，不可编辑
      },
      expandedRowKeys: [],
      searchType: 0,
      productId: undefined,
      productName: undefined,
      token: undefined,
      merchantId: undefined,
      slideNumber: 0,
      isOpen: false,
      title: '',
      selectedName: '',
      dynamicHeight: 0,
      specifications: [],
      //存放要和选中的值进行匹配的数据
      shopItemInfo: {},
      //存放被选中的值
      selectArr: [],
      //是否选中 因为不确定是多规格还是单规格，所以这里定义数组来判断
      subIndex: [],
      //最终匹配到的数据（id/名称）
      boxArr: {},
      matchObj: {
        price: 0
      },
      imgUrl: '',
      vipLevel: 0,
      skuDesInfo: {
        skuVOList: [
          {
            specOptionVOS: []
          }
        ]
      },
      stateList: [],
      scrollPosition: 0,
      logisticsList: [
        {
          checked: true,
          key: 'STANDARD SHIPPING',
          name: 'Standard Shipping',
          skuVOList: [],
        },
        {
          checked: false,
          key: 'FAST SHIPPING',
          name: 'Express Shipping',
          skuVOList: [],
        },
        {
          checked: false,
          key: 'STANDARD SHIPPING(FAST)',
          name: 'Standard Shipping(FAST)',
          skuVOList: [],
        }
      ],
      tableLocale: {
        emptyText: 'Not Supported Yet',
      },
      columns: [
        {
          title: 'Shipping to',
          dataIndex: 'divisionName',
          width: '25%'
        },
        {
          title: 'Product code',
          dataIndex: 'sn',
          width: '25%'
        },
        {
          title: 'First item',
          dataIndex: 'price',
          scopedSlots: {customRender: 'price'},
          width: '25%'
        },
        {
          title: 'Additional item',
          dataIndex: 'extraPrice',
          scopedSlots: {customRender: 'extraPrice'},
          width: '25%'
        },
      ],
      designSpecContent: '',
      adBanner: '',
      recommendList: [],
      menuData: [],
      expandedMenu: new Map(),
      expandedMenuName: new Map(),
      selectNames: [],
      activeIdx: 0,
      swiperOptionTop: {
        spaceBetween: 10,
        effect: 'fade',
        loop: false,
        loopedSlides: 7,
        navigation: {
          prevEl: '.button-prev',
          nextEl: '.button-next',
        },
      },
      swiperOptionThumbs: {
        direction: 'vertical',
        centeredSlides: true,
        spaceBetween: 5,
        loop: false,
        observer: true,
        mousewheel: true,
        slidesPerView: 7,
        loopedSlides: 7,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
      },
    }
  },
  computed: {
    getBorderStyle () {
      return function (level, index, list) {
        if (index === list.length - 1) {
          if (this.token) {
            return 'borderBottom: 2px solid #C8DFF9'
          }
          if (level === 0) {
            return 'borderBottom: 2px solid #C8DFF9'
          } else if (level === 1) {
            return 'borderBottom: 2px solid #FBE5BB'
          } else if (level === 2) {
            return 'borderBottom: 2px solid #CDA9FF'
          }
        }
        return ''
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.title = window.location.href

  },
  created () {
    if (this.$route.path.indexOf('/products') > -1) {
      this.searchType = 1
      this.productName = this.$route.params.name || undefined
    } else {
      this.searchType = 0
      this.productId = this.$route.params.id || undefined
    }
    this.token = this.$route.query.token || undefined
    this.merchantId = this.$route.query.merchantId || undefined
    this.vipLevel = this.$route.query.vipLevel || 0
    this.getProductDes()
    this.getAdBanner()
  },
  methods: {
    uuid,
    updateSkuList () {
      var that = this
      const array = []
      const specNames = []
      const specNameOptions = {}
      this.skuDesInfo.specOptionsVOS.forEach(vo => {
        if (vo.type === 0) {
          let optionNames = vo.colorOptionVOList.map(item => item.optionName)
          array.push({name: vo.specsName, data: optionNames, type: 0})
          specNames.push(vo.specsName)
          specNameOptions[vo.specsName] = optionNames
        } else {
          array.push({name: vo.specsName, data: vo.optionNames, type: 1})
          specNames.push(vo.specsName)
          specNameOptions[vo.specsName] = vo.optionNames
        }
      })
      const skuSpecOptions = getCartesianProduct(array)
      const optionNames = new Map()
      const optionNameOptions = new Map()
      skuSpecOptions.forEach(spec => {
        const option = []
        let optionNameStr = ''
        specNames.forEach(specName => {
          option.push({specsName: specName, optionName: spec[specName]})
          optionNameStr += spec[specName]
        })
        optionNames.set(optionNameStr, false)
        optionNameOptions.set(optionNameStr, option)
      })
      console.log(optionNames)
      // 就sku 规格项扩充或缩减
      const skuList = []
      this.skuDesInfo.skuViewVOS.forEach((sku, skuIdx) => {
        const newSpecOptions = []
        const options = []

        // 已存在规格-规格值保留、不存规格在删除
        sku.specOptionVOS.forEach(option => {
          if (specNameOptions.hasOwnProperty(option.specsName) && specNameOptions[option.specsName].indexOf(option.optionName) > -1) {
            newSpecOptions[specNames.indexOf(option.specsName)] = option
            options[specNames.indexOf(option.specsName)] = option.optionName
          }
        })

        // 不存在规格补充（不允许重复）
        specNames.forEach((specName, idx) => {
          if (!newSpecOptions.hasOwnProperty(idx)) {
            specNameOptions[specName].forEach(optionName => {
              options[idx] = optionName
              if (optionNames.has(options.join('')) && !optionNames.get(options.join(''))) {
                if (array[idx].type === 0) {
                  newSpecOptions[idx] = {specsName: specName, optionName: optionName, type: 0}
                } else {
                  newSpecOptions[idx] = {specsName: specName, optionName: optionName, type: 1}
                }
              }
            })
          }
        })
        // 不允许重复设置
        if (!optionNames.get(options.join(''))) {
          sku.specOptionVOS = newSpecOptions
          skuList.push(sku)
          optionNames.set(options.join(''), true)
        }
      })
      this.skuDesInfo.skuVOList = skuList
      optionNameOptions.forEach(function (value, key) {
        if (!optionNames.get(key)) {
          const addSku = {'specOptionVOS': value}
          that.skuDesInfo.skuVOList.push(addSku)
        }
      })
    },
    getProductDes () {
      function fetchDetails (res) {
        if (res.code === 200) {
          this.skuDesInfo = res.data
          this.skuDesInfo.desc = '<style type="text/css">table {border-collapse: collapse;}</style>' + this.skuDesInfo.desc
          this.skuDesInfo.skuViewVOS.forEach(item => {
            item['specOptionVOS'] = item.colorOptionVOS ? item.colorOptionVOS.concat(item.specOptionVOS) : item.specOptionVOS
            item.vipPrice.unshift({
              level: this.vipLevel,
              price: item.price
            })
            item.vipPrice.splice(1, 0, {})
            item.vipPrice.splice(3, 0, {})
          })
          this.skuDesInfo.specColorOptionVOS.forEach(obj => {
            obj.type = 0
          })
          this.skuDesInfo.specOptionsVOS.forEach(obj => {
            obj.type = 1
          })
          this.skuDesInfo.specOptionsVOS = this.skuDesInfo.specColorOptionVOS.concat(this.skuDesInfo.specOptionsVOS)
          this.selectDepartment(this.skuDesInfo.skuViewVOS, this.skuDesInfo.id)
          let list = []
          if (this.skuDesInfo.productImg) {
            list.push(this.skuDesInfo.productImg)
          }
          if (this.skuDesInfo.productTemplateImg) {
            list.unshift(this.skuDesInfo.productTemplateImg)
          }
          this.skuDesInfo.atlas = list.concat(this.skuDesInfo.atlas).map((img, i) => ({
            img,
            selected: false,
            index: i
          }))

          if (res.data.designSpecId) {
            this.getGuidelinesDes(res.data.designSpecId)
          }
          this.getCategoryList()
          this.updateSkuList()
          this.getLogisticCharge('STANDARD SHIPPING')
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.carousel.goTo(0, true)
            }, 100)
          })
        } else {
          this.$message.error(res.data.msg)
        }
        this.productId = res.data.id
        this.getRecommendList()
      }

      if (this.searchType === 0) {
        get(`/index/product/detail/byId/${this.productId}`, {
          token: this.token,
          merchantId: this.merchantId
        }).then(res => {
          fetchDetails.call(this, res)
        }).catch(error => {
          console.error(error)
        })
      } else {
        get(`/index/product/detail/byName/${this.productName}`, {
          token: this.token,
          merchantId: this.merchantId
        }).then(res => {
          fetchDetails.call(this, res)
        }).catch(error => {
          console.error(error)
        })
      }
    },
    getLogisticCharge (key) {
      if (this.skuDesInfo.skuViewVOS[0].productCodeLogisticCharge.hasOwnProperty(key)) {
        let list = JSON.parse(JSON.stringify(this.skuDesInfo.skuViewVOS[0].productCodeLogisticCharge[key]))
        this.stateList = list.filter(item => item.extraPrice !== null && item.price !== null)
        this.stateList.forEach((item, index) => {
          item['sn'] = 'ALL'
          item['children'] = []
          item['key'] = `state_${index}`

          this.skuDesInfo.skuViewVOS.forEach((onItem, i) => {
            const charges = JSON.parse(JSON.stringify(onItem.productCodeLogisticCharge[key]))
            const charge = charges[index]
            const childItem = {
              price: charge.price,
              extraPrice: charge.extraPrice,
              sn: onItem.sn,
              key: `child_${i}`
            }

            item.children.push(JSON.parse(JSON.stringify(childItem)))
          })
          const prices = item.children.filter(item => item.price !== null).map(item => Number(item.price))
          if (prices.length > 0) {
            const minPrice = Math.min(...prices)
            const maxPrice = Math.max(...prices)
            item.price = minPrice === maxPrice ? `${minPrice}` : `${minPrice}~${maxPrice}`
          }

          const extraPrice = item.children.filter(item => item.extraPrice !== null).map(item => Number(item.extraPrice))
          if (extraPrice.length > 0) {
            const minExtraPrice = Math.min(...extraPrice)
            const maxExtraPrice = Math.max(...extraPrice)
            item.extraPrice = minExtraPrice === maxExtraPrice ? `${minExtraPrice}` : `${minExtraPrice}~${maxExtraPrice}`
          }

        })
      } else {
        this.stateList = []
      }

    },
    getGuidelinesDes (designSpecId) {
      get(`/index/product/guidelines/${designSpecId}`)
        .then(res => {
          this.designSpecContent = '<style type="text/css">table {border-collapse: collapse;}</style>' + res.data
        })
        .catch(error => {
          console.error(error)
        })

    },
    getCategoryList () {
      get('/index/product/category')
        .then(response => {
          this.menuData = response.data.children
          this.menuData.forEach(l1 => {
            this.expandedMenu.set(l1.id, [l1])
            this.expandedMenuName.set(l1.id, [getSeoLinkName(l1.name)])
            l1.children.forEach(l2 => {
              if (l1.children.length === 1) {
                this.expandedMenu.set(l2.id, [l1])
              } else {
                this.expandedMenu.set(l2.id, [l1, l2])
              }
              if (l2.parentId !== null) {
                this.expandedMenuName.set(l2.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name)])
              }
              l2.children.forEach(l3 => {
                if (l2.children.length === 1) {
                  this.expandedMenu.set(l3.id, [l1, l2])
                } else {
                  this.expandedMenu.set(l3.id, [l1, l2, l3])
                }
                this.expandedMenuName.set(l3.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name), getSeoLinkName(l3.name)])
              })
            })
          })
          const categoryId = this.skuDesInfo.categoryList[this.skuDesInfo.categoryList.length - 1].id
          this.selectNames = this.expandedMenu.get(categoryId)
          this.selectNames.unshift({'name': 'Products', 'id': undefined})
        })
        .catch(error => {
          console.error(error)
        })

    },
    getAdBanner () {
      get(`/index/product/adbanner`)
        .then(res => {
          if (res.code === 200) {
            this.adBanner = res.data
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })

    },
    getRecommendList () {
      get(`/index/product/recommend`, {productId: this.productId})
        .then(res => {
          let dataList = res.data
          dataList.forEach(item => {
            if (!item.productTemplateImg) {
              item['productTemplateImg'] = item.productImg
            }
            const {specColorOptionVOS, specOptionsVOS} = item
            const spec = specColorOptionVOS.map(({
              colorOptionVOList,
              specsName
            }) => `${colorOptionVOList.length} ${specsName}`).join(' ')
            const spec1 = specOptionsVOS.map(({
              optionNames,
              specsName
            }) => `${optionNames.length} ${specsName}`).join(' ')
            item.spec = `${spec} ${' '.repeat(3)} ${spec1}`
          })
          const rightDisplay = dataList.reduce((acc, item, index) => {
            const groupIndex = Math.floor(index / 7)
            if (!acc[groupIndex]) {
              acc[groupIndex] = {imgs: []}
            }
            acc[groupIndex].imgs.push({
              productImg: item.productImg,
              id: item.id,
              productTemplateImg: item.productTemplateImg,
              productNameEn: item.productNameEn,
              minPrice: item.minPrice,
              spec: item.spec,
              seoCustomerAddress: item.seoCustomerAddress,
            })
            return acc
          }, [])
          rightDisplay.reverse()
          this.recommendList = rightDisplay
        })
        .catch(error => {
          console.error(error)
        })

    },

    hideArrows () {
      const prevArrow = document.getElementById('prevArrow')
      const nextArrow = document.getElementById('nextArrow')
      prevArrow.style.opacity = '1'
      nextArrow.style.opacity = '1'
    },
    showArrows () {
      const prevArrow = document.getElementById('prevArrow')
      const nextArrow = document.getElementById('nextArrow')
      prevArrow.style.opacity = '0'
      nextArrow.style.opacity = '0'
    },
    //接口初始化、选择产品
    selectDepartment (item, selectedVid) {
      this.selectArr = []
      const attrList = setDataToSpecs(item)

      const differenceList = setDifferenceArray(this.skuDesInfo.skuViewVOS)
      differenceList.forEach(item => {
        this.$set(this.shopItemInfo, item.difference, item)
      })
      attrList.forEach(attr => {
        attr.item.forEach(item => {
          this.$set(item, 'checked', true)
        })
      })
      this.specifications = [...attrList]
      this.initSelectedById(differenceList, selectedVid)
    },
    /**
     * 根据默认id初始化选中状态
     * @param list
     * @param selectedId
     */
    initSelectedById (list, selectedId) {
      const selectedItem = list[0]
      if (selectedItem) {
        const selectedAttributes = selectedItem.difference.split(',')
        selectedAttributes.forEach((attr, index) => {
          const attrItem = this.specifications[index].item.find(item => item.name === attr)
          if (attrItem) {
            attrItem.checked = true
            this.selectArrayBtn(attrItem, index, this.specifications[index].item.indexOf(attrItem))
          }
        })
      }
    },
    selectArrayBtn (item, index, arrayIndex) {
      this.$forceUpdate()
      if (this.selectArr[index] !== item.name) {
        this.selectArr[index] = item.name
        this.subIndex[index] = arrayIndex
      } else {
        return
        // this.selectArr[index] = ''
        // this.subIndex[index] = -1
      }
      this.checkItem()
      const selectObj = this.shopItemInfo[this.selectArr.join(',')]
      if (selectObj) {
        this.boxArr = {id: selectObj.id, difference: selectObj.difference}
      } else {
        this.boxArr = {}
      }

      if (!isIdEmpty(this.boxArr)) {
        this.matchObj = this.skuDesInfo.skuViewVOS.find(item => item.id === this.boxArr.id)
      }
    },
    checkItem () {
      const array = this.specifications
      let result = []
      for (let i in array) {
        result[i] = this.selectArr[i] ? this.selectArr[i] : ''
      }

      for (let i in array) {
        let last = result[i]
        for (let k in array[i].item) {
          result[i] = array[i].item[k].name
          array[i].item[k].checked = this.isMay(result)
        }
        result[i] = last
      }
      this.specifications = array
    },
    isMay (result) {
      for (let i in result) {
        if (result[i] == '') return true
      }
      const selectedValue = this.shopItemInfo[result.join(',')]
      return selectedValue ? true : false
    },
    selectImage (row, index) {
      this.skuDesInfo.atlas.forEach(item => {
        if (row.img === item.img) {
          item.selected = true
        } else {
          item.selected = false
        }
      })
    },
    handleSelectRecommend (item) {
      window.open(`/products/${item.seoCustomerAddress}`, '_blank')
    },
    isShowTag (item, name) {
      const hasIsName = (item.tagList && item.tagList.some(item => item.showName && item.showName.toLowerCase() === name.toLowerCase())) || false
      return hasIsName
    },
    getWechatTitle () {
      if (this.skuDesInfo.productNameEn) {
        return this.skuDesInfo.productNameEn + ' | Printbelle'
      } else {
        return 'Printbelle: Create Print on Demand Products & Fullfillment Service'
      }
    },
    getImgUrl (i) {
      let url = this.skuDesInfo.atlas[i].img
      return this.$options.filters['imgFilter'](url)
    },
    goToSlidePrev () {
      this.scrollPosition = this.scrollPosition + 83
    },
    goToSlideNext () {
      this.scrollPosition = this.scrollPosition - 83
    },
    // 根据 props 更新 customPaging 样式
    customPagingStyle (props) {
      return {
        transform: `translate3d(0px, ${this.scrollPosition}px, 0px)`,
      }
    },
    toNewOrder () {
      window.open(process.env.VUE_APP_FULFILLMENT + 'order/orderlist?productId=' + this.productId, '_blank')
    },
    toCreateTemplate () {
      if (this.skuDesInfo.hasDesignTemplate) {
        window.open(process.env.VUE_APP_FULFILLMENT + 'product/designer?templateId=&productId=' + this.productId, '_blank')
      }
    },
    tableChange (row, i) {
      this.logisticsList.forEach(item => {
        if (row.key === item.key) {
          item.checked = true
          this.getLogisticCharge(row.key)
        } else {
          item.checked = false
        }

      })
    },
    callback (key) {
      console.log(key)
    },
    toProducts (id) {
      if (id) {
        let names = this.expandedMenuName.get(id)
        let urlParams = names.join('/')
        window.location.href = `/products/category/${urlParams}`
      } else {
        window.location.href = `/products`
      }
    },
    adjustIframeSize () {
      const iframe = this.$refs.myIframe
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document
      if (iframeDocument) {
        const body = iframeDocument.body
        const html = iframeDocument.documentElement

        const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
        const width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth)

        iframe.style.height = `${height + 30}px`
        iframe.style.width = `${width}px`
      }
    },
  },
}
</script>
<style lang="less">

.ant-tabs-nav .ant-tabs-tab {
  padding: 12px 0;
  margin: 0 50px 0 0;

}

.content_details {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  margin-top: 96px;

  .ad_banner {
    width: 100%;
    height: 128px;
    background: #FFFFFF;
  }

  .content_info {
    display: flex;
    flex-direction: column;
    padding: 10px 210px 50px 210px;

    .label {
      font-family: Roboto;
      display: flex;
      flex-direction: row;
      font-weight: 400;
      font-size: 16px;
      margin-left: -85px;
      color: #666666;
      line-height: 36px;
    }

    .banner_box {
      display: flex;
      margin-top: 20px;

      .swiper_box {
        width: 580px;
        height: 580px;
        display: flex;
        position: relative;
        -webkit-user-select: none;

        .ant-carousel {
          height: 580px;
          width: 580px;

          .slick-dots {
            width: 76px;
            height: 580px;
          }

          .slick-slide {
            text-align: center;
            height: 580px;
            line-height: 580px;
            overflow: hidden;

            .img_box {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 580px;
              width: 580px;

              img {
                height: 580px;
                width: 580px;
              }
            }
          }

          .slick-thumb::-webkit-scrollbar {
            width: 0;
            height: 0;
          }

          .slick-thumb {
            height: 580px;
            overflow: hidden;
            left: -88px;
            top: 0;

            .slick-active {
              img {
                filter: grayscale(0%);
                width: 72px;
                height: 72px;
                border: 2px solid #343183;
              }
            }

            li {
              display: flex;
              flex-direction: column;
              width: 76px;
              height: 76px;
              margin-bottom: 8px;
              border-radius: 2px;

              img {
                width: 72px;
                height: 72px;
                border-radius: 2px;
                border: 2px solid #E3E4E5;
              }


            }
          }

          .slick_arrow {
            z-index: 1;
            transition: all ease 0.6s;
            color: #504c8f;
          }

          .slick-next::before {
            content: '' !important;
          }

          .slick-prev::before {
            content: '' !important;
          }
        }


        .dots_prev_button {
          width: 71px;
          height: 26px;
          line-height: 30px;
          z-index: 100;
          text-align: center;
          cursor: pointer;
          background: rgba(0, 0, 0, 0.24);
          top: 0;
          left: -84px;
          position: absolute;
          transition: all ease 0.6s;
        }

        .dots_prev_button:hover {
          background: #343183;
        }

        .dots_next_button {
          width: 71px;
          height: 26px;
          line-height: 30px;
          z-index: 100;
          text-align: center;
          background: rgba(0, 0, 0, 0.24);
          bottom: 0;
          left: -84px;
          cursor: pointer;
          position: absolute;
          transition: all ease 0.6s;
        }

        .dots_next_button:hover {
          background: #343183;
        }

        .button-next {
          position: absolute;
          top: 45%;
          opacity: 0;
          right: 5px;
          transition: all ease 0.6s;
        }

        .gallery-top .button-next:hover {
          opacity: 1;
        }

        .button-prev {
          position: absolute;
          top: 45%;
          opacity: 0;
          left: 5px;
          transition: all ease 0.6s;
        }

        .gallery-top .button-prev:hover {
          opacity: 1;
        }

        .gallery-top .swiper-slide img {
          width: 580px;
          height: 580px;
          object-fit: cover;
        }

        .gallery-thumbs {
          width: 76px;
          height: 580px !important;
          display: flex;
          flex-direction: column;

        }

        .gallery-thumbs .swiper-wrapper {
          margin-top: -250.714px;
        }

        .gallery-thumbs .swiper-slide {
          width: 76px;
          height: 78px;
          cursor: pointer;
          border: 2px solid #eaeaea;
          align-self: flex-start;
        }

        .gallery-thumbs .swiper-slide img {
          width: 72px;
          height: 74px;
          object-fit: cover;
        }

        .gallery-thumbs .swiper-slide-active {
          opacity: 1;
          border: 2px solid #343183;
        }
      }

      .banner_info {
        margin-left: 71px;
        margin-top: -10px;

        .title {
          font-weight: bold;
          font-family: Roboto;
          font-size: 32px;
          line-height: 50px;
          color: #222222;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin-bottom: 15px;
        }

        .price_view {
          height: 121px;
          background: #F8FAFC;
          border-radius: 10px;
          padding-left: 29px;
          padding-top: 12px;
        }

        .price {
          font-family: Roboto;
          font-weight: 500;
          font-size: 18px;
          color: #555555;
        }

        .price_box {
          display: flex;
          padding-left: 3px;
          margin-top: 8px;

          .item {
            width: 260px;
            display: flex;
            flex-direction: column;

            .item_price {
              font-family: Roboto;
              font-weight: bold;
              font-size: 32px;
              color: #222222;
              line-height: 36px;
            }

            .item_rank {
              font-family: Roboto;
              font-weight: 400;
              font-size: 16px;
              color: #555555;
              line-height: 16px;
              margin-top: 6px;
            }

            .item_time {
              font-family: Roboto;
              font-weight: 500;
              font-size: 18px;
              color: #555555;
              line-height: 18px;
            }

            .item_day {
              font-family: Roboto;
              font-weight: bold;
              font-size: 32px;
              line-height: 50px;
              color: #222222;
            }

          }
        }

        .spec_box {
          display: flex;
          margin-top: 20px;
          flex-direction: column;


          .subhead {
            font-family: Roboto;
            font-weight: 500;
            font-size: 18px;
            color: #555555;
            line-height: 50px;
          }

          .spec_list {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 5px;

            .spec_item {
              min-width: 60px;
              padding: 0 8px;
              height: 39px;
              border-radius: 4px;
              cursor: pointer;
              background: #FFFFFF;
              border: 1px solid #E3E4E5;
              margin-right: 12px;
              margin-bottom: 10px;
              font-family: Roboto;
              font-weight: 500;
              font-size: 18px;
              color: #222222;
              line-height: 41px;
              text-align: center;
            }

            .noneActive {
              background: #ccc;
              border: 1px solid #ccc;
              opacity: 0.4;
              color: #222222;
              pointer-events: none;
            }

            .active {
              background: #F8FAFC;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
              border-radius: 4px;
              border: 1px solid #343183;
            }

            .spec_item1 {
              width: 42px;
              height: 42px;
              background: #FFFFFF;
              border: 1px solid #ccc;
              border-radius: 50%;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 12px;
              margin-bottom: 10px;
            }

            .noneActive1 {
              background: #ccc;
              border: 1px solid #343183;
              border-radius: 50%;
              opacity: 0.4;
              pointer-events: none;
            }

            .active1 {
              background: rgba(118, 31, 234, 0.08);
              border: 1px solid #343183;
            }
          }
        }

        .btn_box {
          display: flex;
          margin-top: 33px;

          .btn {
            width: 250px;
            height: 52px;
            background: #E40F0A;
            border-radius: 4px;
            font-family: Roboto;
            font-weight: 500;
            text-align: center;
            font-size: 16px;
            color: #FFFFFF;
            cursor: pointer;
            line-height: 53px;
          }

          .btn1 {
            width: 250px;
            height: 53px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #E3E4E5;
            margin-left: 20px;
            font-family: Roboto;
            text-align: center;
            font-weight: 400;
            font-size: 16px;
            color: #222222;
            cursor: pointer;
            line-height: 53px;
          }

          .disabled {
            background: #e2e2e2;
            cursor: no-drop;
          }
        }
      }
    }
  }

  .tabs_box {
    margin: 0 200px 50px 210px;

    .ant-tabs-nav {
      font-family: Roboto;
      font-weight: bold;
      font-size: 18px;
    }

    .spec_des_box {
      margin-top: 10px;

      .empty_th {
        width: 18px;
        padding: 16px 0;
      }

      .empty_td {
        width: 18px;
        padding: 16px 0;
      }

      .th_price {
        width: 182px;
        height: 67px;
        text-align: center;
        background: rgba(173, 208, 237, 0.2);
        border-radius: 10px 10px 0 0;
        border-image: linear-gradient(0deg, #588ABD, #C8DFF9) 10 10;
        position: relative;
        z-index: 2;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .th_price:before {
        width: 184px;
        height: 67px;
        content: "";
        position: absolute;
        top: 0;
        left: -1px;
        border-top: 2px solid #C8DFF9;
        border-right: 2px solid #C8DFF9;
        border-left: 2px solid #C8DFF9;
        border-bottom: 2px solid #5587B9;
        border-radius: 10px 10px 0 0;
      }

      .th_price1 {
        width: 182px;
        height: 67px;
        text-align: center;
        background: rgba(227, 182, 107, 0.2);
        border-radius: 10px 10px 0 0;
        border-image: linear-gradient(0deg, #B58941, #FBE5BB) 10 10;
        position: relative;
        z-index: 1;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .th_price1:before {
        width: 184px;
        height: 67px;
        content: "";
        position: absolute;
        top: 0;
        left: -1px;
        border-top: 2px solid #FBE5BB;
        border-right: 2px solid #FBE5BB;
        border-left: 2px solid #FBE5BB;
        border-bottom: 2px solid #E19D31;
        border-radius: 10px 10px 0 0;
      }

      .th_price2 {
        width: 182px;
        height: 67px;
        text-align: center;
        background: rgba(144, 71, 243, 0.2);
        border-image: linear-gradient(0deg, #761FEA, #CDA9FF) 10 10;
        border-radius: 10px 10px 0 0;
        position: relative;
        z-index: 2;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .th_price2:before {
        width: 184px;
        height: 67px;
        content: "";
        position: absolute;
        top: 0;
        left: -1px;
        border-top: 2px solid #CDA9FF;
        border-right: 2px solid #CDA9FF;
        border-left: 2px solid #CDA9FF;
        border-bottom: 2px solid #8029F3;
        border-radius: 10px 10px 0 0;
      }

      .td_price {
        border-right: 2px solid #C8DFF9;
        border-left: 2px solid #C8DFF9;
      }

      .td_price1 {
        border-right: 2px solid #FBE5BB;
        border-left: 2px solid #FBE5BB;
      }

      .td_price2 {
        border-right: 2px solid #CDA9FF;
        border-left: 2px solid #CDA9FF;
      }

      .last_td {
        border-bottom: 2px solid #C8DFF9;
      }

      .last_td1 {
        border-bottom: 2px solid #FBE5BB;
      }

      .last_td2 {
        border-bottom: 2px solid #CDA9FF;
      }
    }

    .logistics_box {
      display: flex;
      flex-direction: column;

      .table_box {
        display: flex;
        margin: 15px 0 30px 0;

        .item {
          cursor: pointer;
          padding: 0 15px;
          border-radius: 16px;
          line-height: 34px;
          text-align: center;
          margin-right: 10px;
          height: 34px;
          background: #FFFFFF;
          border-radius: 16px;
          border: 1px solid #E3E4E5;
          font-family: Roboto;
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }

        .active {
          color: #FFFFFF;
          background: #343183;
          border: 1px solid #E3E4E5;
        }
      }
    }
  }

  .item_divider {
    height: 1px;
    background: #E3E4E5;
    margin: 30px 210px 50px 210px;
  }

  .like_box {
    display: flex;
    flex-direction: column;
    padding: 0px 148px 53px 148px;

    .title {
      font-family: Roboto;
      font-weight: bold;
      font-size: 28px;
      color: #333333;
      text-align: center;
      line-height: 36px;
      margin-bottom: 45px;
    }

    .ant-carousel .slick-slide {
      width: 200px;
      height: 300px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;

      .hotBox {
        width: 200px;
        float: left;
        pointer-events: auto;
        margin-left: 8px;
        margin-right: 8px;

        .slide_box:hover {
          background: #F8FAFC;
          border-radius: 4px;
        }

        .slide_box {
          width: 198px;
          height: 290px;
          border-radius: 6px;
          justify-content: center;
          align-items: center;
          position: relative;

          .img_box {
            width: 198px;
            height: 198px;
            position: relative;
            overflow: hidden;
            border-radius: 3px;
            transition: all ease 0.3s;


            .img1 {
              width: 100%;
              height: 100%;
              opacity: 1;
              position: absolute;
              border-radius: 3px;
              top: 0;
              transition: all ease 0.6s;
            }

            .img2 {
              width: 100%;
              height: 100%;
              opacity: 0;
              border-radius: 3px;
              position: absolute;
              top: 0;
              transition: all ease 0.6s;
            }
          }

          .name {
            width: 198px;
            font-family: Roboto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 11px 6px;
            font-weight: 500;
            font-size: 18px;
            line-height: 18px;
            color: #222222;
          }

          .price {
            width: 198px;
            font-family: Roboto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            margin: 0 6px;
            font-weight: 400;
            font-size: 18px;
            line-height: 18px;
            color: #343183;
          }

          .size {
            width: 198px;
            font-family: Roboto;
            font-weight: 300;
            font-size: 15px;
            color: #485256;
            margin: 0 6px;
            line-height: 31px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
          }

          .tag_box {
            display: flex;
            position: absolute;
            height: 19px;
            top: 10px;
            left: 6px;
            font-family: Roboto;
            font-weight: 400;

            .best {
              height: 19px;
              background: #FFDEE0;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              margin-right: 3px;
              text-align: center;
              border: 1px solid #FF000C;
              color: #FF000C;
            }

            .new {
              height: 19px;
              background: #FFE0C5;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              margin-right: 3px;
              text-align: center;
              border: 1px solid #F6790F;
              color: #F6923D;
            }

            .trd {
              height: 19px;
              background: #E2E1FF;
              border-radius: 3px;
              padding: 0 5px;
              font-size: 14px;
              line-height: 17px;
              text-align: center;
              border: 1px solid #343183;
              color: #343183;
            }
          }
        }

        .slide_box:last-child {
          margin-right: 0;
        }


        .slide_box:hover .img_box .img1 {
          opacity: 0;
          transform: scale(1.1);
        }

        .slide_box:hover .img_box .img2 {
          opacity: 1;
          transform: scale(1.1);
        }
      }


    }

    .ant-carousel .custom-slick-arrow {
      width: 40px;
      height: 40px;
      margin: auto;
      position: absolute;
      top: calc((100% - 40px) / 2);
      opacity: 0.6;
      transform: translateY(-50%);
      z-index: 50;
      transition: all ease 0.6s;
    }

    .custom-slick-arrow:before {
      display: none;
    }

    .ant-carousel .custom-slick-arrow:hover {
      opacity: 1;

    }
  }

  .ant-table-thead > tr > th {
    font-family: Roboto;
    font-weight: 500;
    font-size: 18px;
    padding: 16px 1px;
    text-align: center;
    color: #222222;
  }

  .ant-table-tbody > tr > td {
    font-family: Roboto;
    font-weight: 300;
    font-size: 16px;
    text-align: center;
    padding: 16px 1px;
    color: #222222;
  }

  .ant-table {
    color: #222222;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Details.vue